module.exports = __webpack_public_path__ + "img/bell.3760333b.svg";